// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__8mbEq","content":"styles_content__IYS3E","label":"styles_label__LJ_on"};